import {AbstractApiService} from './AbstractApiService';

class PaymentService extends AbstractApiService {
    constructor() {
        super('', process.env.VUE_APP_API_BASE_URL || '/');
    }

    show(msisdn) {
        // console.log('PaymetService.show ', msisdn);
        let response = this.http.post('/api/payment', {msisdn: msisdn})
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
        // console.log('PaymentService.show response: ', JSON.stringify(response));
        return response;
    }

    create(msisdn, email, provider, distributor, tariffId, isActiveTariff, nextRenewalDate, nextRenewalHumanDate) {
        let response = this.http.post('/api/payment/create', {
            msisdn: msisdn,
            email: email,
            provider: provider,
            distributor: distributor,
            tariffId: tariffId,
            isActiveTariff: isActiveTariff,
            nextRenewalDate: nextRenewalDate,
            nextRenewalHumanDate: nextRenewalHumanDate
        })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
        return response;
    }

    get(buyorder, msisdn) {
        // console.log('PaymetService.get ', buyorder);
        const query = msisdn ? `?msisdn=${encodeURIComponent(msisdn)}` : '';
        let response = this.http.get('/api/payment/' + buyorder + query)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
        // console.log('PaymentService.get response: ', JSON.stringify(response));
        return response;
    }
}

export const paymentService = new PaymentService();
